import { __assign, __extends } from "tslib";
import React, { Component } from "react";
import { PnmacHtmlToNative, PnmacMediaQuery, PnmacMeta, PnmacModal, PnmacNativeFetch, PnmacPageBubble } from "pnmac-universal-components";
import { connect } from "react-redux";
import * as Actions from "../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import { ActivityIndicator, Image, Linking, Platform, Text, TouchableOpacity, View } from "react-native";
import saveFilePDF from '../saveFilePDF';
import { textStyle } from "../v2/theme/textStyle";
var ModForms = /** @class */function (_super) {
  __extends(ModForms, _super);
  function ModForms(props) {
    var _this = _super.call(this, props) || this;
    _this.fetchModFormPdf = function (formTemplateId, templateName, modified, templateType) {
      var layout = _this.props.layout;
      var body = JSON.stringify({
        templateId: formTemplateId,
        loanId: layout.selectedLoanNumber,
        templateType: templateType,
        uploadDate: modified,
        templateName: templateName
      });
      var url = layout.pennyHomeUrl + "api/modification/get_downloadableModForm_by_templateId";
      if (layout.mobile == true) {
        saveFilePDF({
          url: url,
          body: body,
          method: 'POST',
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            'Authorization': "Bearer ".concat(layout.token)
          },
          fileName: templateName + templateType
        });
      } else {
        fetch(url, {
          body: body,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': "Bearer ".concat(layout.token)
          }
        }).then(function (response) {
          return response.blob();
        }).then(function (response) {
          var blob = new Blob([response], {
            type: 'application/pdf'
          });
          var downloadUrl = URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = downloadUrl;
          a.download = templateName;
          a.target = "_blank";
          document.body.appendChild(a);
          a.click();
        });
      }
    };
    _this.state = {
      base64: null,
      formTemplateId: null,
      modFormView: false,
      loading: false
    };
    return _this;
  }
  ModForms.prototype.render = function () {
    var _this = this;
    var _a = this,
      props = _a.props,
      state = _a.state;
    var translations = props.translations,
      layout = props.layout;
    var modTemplates = layout.modTemplates;
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      return /*#__PURE__*/React.createElement(View, {
        id: "main-content",
        className: "container px-5 pb-5 pt-4",
        style: {
          margin: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: translations.ModificationForms
      }), /*#__PURE__*/React.createElement(PnmacPageBubble, {
        idTag1: "modFormDescription",
        accessibilityRole: "header",
        ariaLevel: "1",
        text: translations.ModificationForms,
        containerStyles: {
          marginLeft: 0,
          marginBottom: 0,
          marginTop: 0
        }
      }), /*#__PURE__*/React.createElement(View, {
        style: {
          marginTop: 10,
          marginBottom: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
        value: translations.FormDesc
      }))), /*#__PURE__*/React.createElement(TouchableOpacity, {
        style: {
          flexDirection: "row",
          alignItems: "center",
          marginVertical: 10
        },
        id: "downloadReader",
        onPress: function () {
          return Linking.openURL("https://get.adobe.com/reader/");
        }
      }, Platform.OS === 'web' ? /*#__PURE__*/React.createElement("img", {
        src: require('../assets/pdf.png'),
        alt: "Download Adobe Reader"
      }) : /*#__PURE__*/React.createElement(Image, {
        source: require("../assets/pdf.png"),
        alt: "Download Adobe Reader"
      }), /*#__PURE__*/React.createElement(Text, {
        style: {
          fontSize: Platform.OS === 'web' ? 18 : 14,
          marginLeft: 10
        }
      }, "Download Adobe Reader")), /*#__PURE__*/React.createElement(View, {
        style: {
          marginTop: 10,
          marginBottom: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
        value: translations.ModMAADescription
      }))), (modTemplates || []).map(function (s, i) {
        var _a, _b;
        return /*#__PURE__*/React.createElement(TouchableOpacity, {
          key: "modTemplate" + ((_a = s.data) === null || _a === void 0 ? void 0 : _a.templateId),
          onPress: function () {
            var _a, _b, _c, _d;
            return _this.fetchModFormPdf((_a = s.data) === null || _a === void 0 ? void 0 : _a.templateId, (_b = s.data) === null || _b === void 0 ? void 0 : _b.displayName, (_c = s.data) === null || _c === void 0 ? void 0 : _c.modified, (_d = s.data) === null || _d === void 0 ? void 0 : _d.templateType);
          }
        }, /*#__PURE__*/React.createElement(Text, {
          style: __assign({
            width: "auto",
            cursor: "pointer"
          }, textStyle.clickableLink)
        }, "\u2022 ", (_b = s.data) === null || _b === void 0 ? void 0 : _b.displayName));
      }), /*#__PURE__*/React.createElement(PnmacModal, {
        "aria-labelledby": "transition-modal-title",
        "aria-describedby": "transition-modal-description",
        open: _this.state.loading,
        closeAfterTransition: true
      }, /*#__PURE__*/React.createElement(ActivityIndicator, {
        size: "large"
      })));
    });
  };
  return ModForms;
}(Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(ModForms);